import { SvgIcon } from "@mui/material";
import { IconProps } from "./_interface";

const ProjectIcon = (props: IconProps) => {
  return (
    <SvgIcon {...props} width="49" height="48" color="inherit" viewBox="0 0 49 48" fill="none">
      <circle cx="24.334" cy="24" r="24" fill="#F5E4E7"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M13.334 13.75C13.334 12.2312 14.5652 11 16.084 11H32.084C33.6028 11 34.834 12.2312 34.834 13.75V33.75C34.834 35.2688 33.6028 36.5 32.084 36.5H16.084C14.5652 36.5 13.334 35.2688 13.334 33.75V13.75Z" fill="#C72037"/>
      <path d="M18.084 17.5C18.084 17.0858 18.4198 16.75 18.834 16.75H27.334C27.7482 16.75 28.084 17.0858 28.084 17.5C28.084 17.9142 27.7482 18.25 27.334 18.25H18.834C18.4198 18.25 18.084 17.9142 18.084 17.5Z" fill="#fff"/>
      <path d="M18.084 23.5C18.084 23.0858 18.4198 22.75 18.834 22.75H23.334C23.7482 22.75 24.084 23.0858 24.084 23.5C24.084 23.9142 23.7482 24.25 23.334 24.25H18.834C18.4198 24.25 18.084 23.9142 18.084 23.5Z" fill="#fff"/>
      <path d="M18.084 29.5C18.084 29.0858 18.4198 28.75 18.834 28.75H29.334C29.7482 28.75 30.084 29.0858 30.084 29.5C30.084 29.9142 29.7482 30.25 29.334 30.25H18.834C18.4198 30.25 18.084 29.9142 18.084 29.5Z" fill="#fff"/>
    </SvgIcon>
  );
};

export default ProjectIcon;
